import { Main } from "@/components/Main";
import { CreateLoaderTable } from "@/components/Loaders";
import { TableData } from "@/App/Distributions/UnityToUnity/Table";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/hooks/auth";
import { getContestssData } from "@/Api/contests";
import { useNavigate } from "react-router-dom";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction } from "@/components/ui/alert-dialog";
import { colors } from "@/utils/colors";
import { cn } from "@/lib/utils";


export default function UnityToUnityDistributions() {
  const [state, setState] = useState<"loading" | "production" | "error">(
    "loading"
  );
  const [dataApi, setDataApi] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAccessDialog, setShowAccessDialog] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const unityId = user?.unity?.[0]?.id;
  useEffect(() => {
    if (user?.user_type_id !== 4) {
      setShowAccessDialog(true);
    }
  }, [user]);

  const fetchData = useCallback(async (page = 1) => {
    if (!unityId) {
      setState("error");
      return;
    }

    try {
      setState("loading");
      const { data } = await getContestssData(page, {
        contest_status_id: 1,
        is_active: 1
      });
      
      if (data?.status) {
        setDataApi(data.response);
        setState("production");
      } else {
        setState("error");
      }
    } catch (error) {
      console.error(error);
      setState("error");
    }
  }, [unityId]);

  useEffect(() => {
    fetchData(1);
  }, [fetchData]);

  const pageActions = {
    update: () => {
      fetchData(currentPage);
    },
    next: () => {
      const nextPage = currentPage + 1;
      if (dataApi && nextPage <= dataApi.last_page) {
        setCurrentPage(nextPage);
        fetchData(nextPage);
      }
    },
    previous: () => {
      const prevPage = currentPage - 1;
      if (prevPage >= 1) {
        setCurrentPage(prevPage);
        fetchData(prevPage);
      }
    },
    lastPage: () => {
      if (dataApi) {
        setCurrentPage(dataApi.last_page);
        fetchData(dataApi.last_page);
      }
    },
  };

  const handleAccessDialogClose = () => {
    setShowAccessDialog(false);
    navigate("/");
  };

  return (
    <Main>
      <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
        <h2 className="text-2xl font-semibold flex gap-2 items-center">
          Distribuições Entre Unidades
        </h2>
      </div>
      <div className="flex flex-col gap-3">
        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <TableData
            dataApi={dataApi}
            pageActions={pageActions}
            unityId={unityId}
          />
        )}
      </div>

      <AlertDialog open={showAccessDialog} onOpenChange={setShowAccessDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Acesso Negado</AlertDialogTitle>
            <AlertDialogDescription>
              Esta funcionalidade está disponível apenas para usuários do tipo Unity (Gerente de Unidade).
              Seu tipo de usuário atual não tem permissão para acessar as distribuições entre unidades.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              onClick={handleAccessDialogClose}
              className={cn(colors.bg_primary)}
            >
              Entendi
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Main>
  );
}